export enum IMAGE_TOOL {
  REFERENCE2IMAGE = 'reference2image',
  TEXT2IMAGE = 'text2image',
}

export enum VIDEO_TOOL {
  CHARACTER2VIDEO = 'character2video',
  IMG2VIDEO = 'img2video',
  TEXT2VIDEO = 'text2video',
}

export type VideoToolValues = `${VIDEO_TOOL}`;
export type ImageToolValues = `${IMAGE_TOOL}`;

export type CreatePageInfo =
  | {
      toolType: 'image';
      tool: ImageToolValues;
    }
  | {
      toolType: 'video';
      tool: VideoToolValues;
    };
